<form class="k-form k-form-md"
      [formGroup]="treeviewContainerForm">
  <kendo-formfield>
    <kendo-textbox #filterBox
                   formControlName="filterBox"
                   placeholder="Find in filters..."
                   [value]="filterValue"
                   (inputBlur)="onFilterInputBlur()"
                   (inputFocus)="onFilterInputFocus()"
                   (valueChange)="onFilterChange($event)">
    </kendo-textbox>
  </kendo-formfield>
  <div class="criteria">
    <ng-content></ng-content>
  </div>
</form>
